// src/lib/trialGate.js — FASE 3 · Trial mobile read-only (plano de planos 04/06).
// Nos shells de campo (supervisor/funcionário/cliente), tenant em TRIAL não escreve:
// toda ação de escrita passa por guardTrial() — bloqueia, mostra upsell e retorna true.
// O admin (desktop) do trial segue escrevendo (dados seed). Enforcement real: migração 16.

import { tenant } from '../context/tenantContext.js';
import { showToast } from './toast.js';

/** Trial em papel de campo? (admin/super_admin ficam de fora) */
export function isTrialReadOnly() {
  return !!tenant.isTrial && !tenant.isAdmin && !tenant.isSuperAdmin;
}

/** Chame no INÍCIO de toda ação de escrita dos shells mobile.
 *  @returns {boolean} true = bloqueado (caller deve dar return). */
export function guardTrial() {
  if (!isTrialReadOnly()) return false;
  showToast('🔒 Disponível ao assinar — no teste grátis o app de campo é somente leitura.', 'info', 3500);
  return true;
}

// ── Cadeado visual nos CTAs de escrita ───────────────────────────────
const LOCK_SELECTORS = [
  // supervisor
  '.rmob-quick .qa.imped', '.rmob-quick .qa.foto', '[data-rdo]:not([data-rdohoje])',
  // funcionário
  '.fmob-ponto-cta', '.fmob-sol-act',
  // cliente (feed)
  '[data-act="like"]', '[data-act="send-comment"]',
].join(',');

let _cssInjected = false;
function _injectCSS() {
  if (_cssInjected) return;
  _cssInjected = true;
  const st = document.createElement('style');
  st.id = 'trial-gate-css';
  st.textContent = `
    .trial-lock{opacity:.55;position:relative}
    .trial-lock::after{content:'🔒';position:absolute;top:-7px;right:-7px;font-size:13px;
      line-height:1;filter:drop-shadow(0 1px 2px rgba(0,0,0,.5))}
  `;
  document.head.appendChild(st);
}

/** Marca visualmente os CTAs de escrita (idempotente). Chamar após cada render do shell. */
export function applyTrialLocks(root = document) {
  if (!isTrialReadOnly()) return;
  _injectCSS();
  root.querySelectorAll(LOCK_SELECTORS).forEach((el) => el.classList.add('trial-lock'));
}
